import   axios                      from 'axios';
import { API_URLS                 } from '../urls';
import { BackendResponse          ,
         handleError              } from '../../dataTypes/backendServicesManagment/types';
import { AdsCampaign            ,
         initializedAdsCampaign   } from '../../dataTypes/adsCampaignManagment/types';

export interface BackendResponse_AdsCampaigns extends BackendResponse<AdsCampaign[]> {}

export const getAdsCampaigns = async (): Promise<BackendResponse_AdsCampaigns> => {
  const url = API_URLS.getAdsCampaigns;

  try {
    const response = await axios.get(url);

    console.log(url, response);

    if (response.status === 200)
          {
           const adsCampaigns: AdsCampaign[] = response.data.map ((campaign: any) => {

             const defaultCampaign = initializedAdsCampaign();

             return {
                      ...defaultCampaign,
                      id                           : campaign.id                           ??                                    defaultCampaign.id                           ,
                      creationDate                 : campaign.creationDate                 ?  new Date(campaign.creationDate)  : defaultCampaign.creationDate                 ,
                      reference                    : campaign.reference                    ??                                    defaultCampaign.reference                    ,
                      totalPriceWithoutTax         : campaign.totalPriceWithoutTax         ??                                    defaultCampaign.totalPriceWithoutTax         ,
                      totalPriceWithTax            : campaign.totalPriceWithTax            ??                                    defaultCampaign.totalPriceWithTax            ,
                      taxRate                      : campaign.taxRate                      ??                                    defaultCampaign.taxRate                      ,
                      agentId                      : campaign.agentId                      ??                                    defaultCampaign.agentId                      ,
                      legalStructureId             : campaign.legalStructureId             ??                                    defaultCampaign.legalStructureId             ,
                      beginningDate                : campaign.beginningDate                ?  new Date(campaign.beginningDate) : defaultCampaign.beginningDate                ,
                      endingDate                   : campaign.endingDate                   ?  new Date(campaign.endingDate)    : defaultCampaign.endingDate                   ,
                      name                         : campaign.id                           ??                                    defaultCampaign.id                           ,
                      channelId                    : campaign.channelId                    ??                                    defaultCampaign.channelId                    ,
                      areaId                       : campaign.areaId                       ??                                    defaultCampaign.areaId                       ,
                      advertisingSpotsNumberPerDay : campaign.advertisingSpotsNumberPerDay ??                                    defaultCampaign.advertisingSpotsNumberPerDay ,
                      spotDuration                 : campaign.spotDuration                 ??                                    defaultCampaign.spotDuration                 ,
                      schedule                     : campaign.schedule                     ??                                    defaultCampaign.schedule                     ,
					  adSpotId                     : campaign.adSpotId                     ??                                    defaultCampaign.adSpotId                     ,
                    };
           });

           return {
                    code    : 1,
                    comment : 'The retrieval of sales campaigns is complete.',
                    payload : adsCampaigns,
                  };
          }
     else {
           return handleError<AdsCampaign[]>(response.status, 'Non-200 response from API');
          }
   }
  catch (error)
   {
    console.log(url, error);

    if (axios.isAxiosError(error))
     {
      return handleError<AdsCampaign[]>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<AdsCampaign[]>(-102, 'Unknown error');
  }
};

export const createAdsCampaign = async ( reference                    : string ,
                                         agentId                      : number ,
                                         totalPriceWithoutTax         : number ,
                                         totalPriceWithTax            : number ,
                                         taxRate                      : string ,
                                         legalStructureId             : number ,
                                         beginningDate                : Date | null ,
                                         endingDate                   : Date | null ,
                                         name                         : string ,
                                         channelId                    : number ,
                                         areaId                       : number ,
                                         advertisingSpotsNumberPerDay : number ,
                                         spotDuration                 : number ,
                                         adSpotId                     : number ,  
                                         schedule                     : Date[] ) => {

  const url = `${API_URLS.createAdsCampaign}`;

  const formData = new FormData();

                       formData.append ( 'reference'                    , reference                               );
                       formData.append ( 'agentId'                      , agentId.toString()                      );
					   formData.append ( 'legalStructureId'             , agentId.toString()                      );
                       formData.append ( 'totalPriceWithoutTax'         , totalPriceWithoutTax.toString()         );
                       formData.append ( 'totalPriceWithTax'            , totalPriceWithTax.toString()            );
                       formData.append ( 'taxRate'                      , taxRate                                 );
                       formData.append ( 'legalStructureId'             , legalStructureId.toString()             );
  if ( beginningDate ) formData.append ( 'beginningDate'                , beginningDate.toISOString()             );
  if ( endingDate    ) formData.append ( 'endingDate'                   , endingDate.toISOString()                );
                       formData.append ( 'name'                         , name                                    );
                       formData.append ( 'channelId'                    , channelId.toString()                    );
                       formData.append ( 'areaId'                       , areaId.toString()                       );
                       formData.append ( 'advertisingSpotsNumberPerDay' , advertisingSpotsNumberPerDay.toString() );
                       formData.append ( 'spotDuration'                 , spotDuration.toString()                 );
                       formData.append ( 'adSpotId'                     , adSpotId.toString()                     );
                       
  try
   {
    const response = await axios.post ( url , formData , { headers: { 'Accept': 'application/ld+json', 'Content-Type': 'multipart/form-data' } } );

    console.log ('createAdsCampaign', response)

    if (response.status === 201)
          {
           return {
                    code    : 1,
                    comment : 'Ads campaign created successfully',
                    payload : {} as any
                  };
          }
     else {
           return handleError<void>(response.status, 'Error creating the sales campaign');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Unknown error occurred');
   }
};


export const deleteAdsCampaign = async (id: number): Promise<BackendResponse> => {

  const url = `${API_URLS.deleteAdsCampaign}`.replace('{id}', `${id}`);

  try
   {
    const response = await axios.delete(url);

    if (response.status === 204)
          {
           return {
                    code    : 1,
                    comment : 'Ads campaign successfully deleted.',
                    payload : {} as any
                  };
          }
     else {
           return handleError<void>(response.status, 'Error deleting the sales campaign');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Unknown error');
   }
};

export const updateAdsCampaign = async ( id                           : number ,
                                         reference                    : string ,
                                         agentId                      : number ,
                                         totalPriceWithoutTax         : number ,
                                         totalPriceWithTax            : number ,
                                         taxRate                      : string ,
                                         legalStructureId             : number ,
                                         beginningDate                : Date | null ,
                                         endingDate                   : Date | null ,
                                         name                         : string ,
                                         channelId                    : number ,
                                         areaId                       : number ,
                                         advertisingSpotsNumberPerDay : number ,
                                         spotDuration                 : number ,
                                         adSpotId                     : number ,  
                                         schedule                     : Date[] ) => {

  const url = `${API_URLS.patchAdsCampaign}`;

  const formData = new FormData();

                       formData.append ( 'id'                           , id.toString()                           );
                       formData.append ( 'reference'                    , reference                               );
                       formData.append ( 'agentId'                      , agentId.toString()                      );
					   formData.append ( 'legalStructureId'             , agentId.toString()                      );
                       formData.append ( 'totalPriceWithoutTax'         , totalPriceWithoutTax.toString()         );
                       formData.append ( 'totalPriceWithTax'            , totalPriceWithTax.toString()            );
                       formData.append ( 'taxRate'                      , taxRate                                 );
                       formData.append ( 'legalStructureId'             , legalStructureId.toString()             );
  if ( beginningDate ) formData.append ( 'beginningDate'                , beginningDate.toISOString()             );
  if ( endingDate    ) formData.append ( 'endingDate'                   , endingDate.toISOString()                );
                       formData.append ( 'name'                         , name                                    );
                       formData.append ( 'channelId'                    , channelId.toString()                    );
                       formData.append ( 'areaId'                       , areaId.toString()                       );
                       formData.append ( 'advertisingSpotsNumberPerDay' , advertisingSpotsNumberPerDay.toString() );
                       formData.append ( 'spotDuration'                 , spotDuration.toString()                 );
                       formData.append ( 'adSpotId'                     , adSpotId.toString()                     );
 
  try
   {
    const response = await axios.post ( url , formData , { headers: { 'Accept': 'application/ld+json', 'Content-Type': 'multipart/form-data' } } );

    console.log ('updateAdsCampaign', response)
  
    if (response.status === 200)
          {
           return {
                    code    : 1,
                    comment : 'Ads campaign updated successfully',
                    payload : {} as any
                  };
          }
     else {
           return handleError<void>(response.status, 'Error updating the sales campaign');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Unknown error occurred');
   }
};

export interface BackendResponse_AdsCampaign extends BackendResponse<AdsCampaign> {}

export const getAdsCampaign = async (id: number): Promise<BackendResponse_AdsCampaign> => {

  const url = `${API_URLS.getAdsCampaign}`.replace('{id}', `${id}`);

  try
   {
    const response = await axios.get(url);

    if (response.status === 200)
          {
           const defaultCampaign = initializedAdsCampaign();

           const ads : AdsCampaign = {
                                       ...defaultCampaign,
                      id                           : response.data.id                           ??                                         defaultCampaign.id                           ,
                      creationDate                 : response.data.creationDate                 ?  new Date(response.data.creationDate)  : defaultCampaign.creationDate                 ,
                      reference                    : response.data.reference                    ??                                         defaultCampaign.reference                    ,
                      totalPriceWithoutTax         : response.data.totalPriceWithoutTax         ??                                         defaultCampaign.totalPriceWithoutTax         ,
                      totalPriceWithTax            : response.data.totalPriceWithTax            ??                                         defaultCampaign.totalPriceWithTax            ,
                      taxRate                      : response.data.taxRate                      ??                                         defaultCampaign.taxRate                      ,
                      agentId                      : response.data.agentId                      ??                                         defaultCampaign.agentId                      ,
                      legalStructureId             : response.data.legalStructureId             ??                                         defaultCampaign.legalStructureId             ,
                      beginningDate                : response.data.beginningDate                ?  new Date(response.data.beginningDate) : defaultCampaign.beginningDate                ,
                      endingDate                   : response.data.endingDate                   ?  new Date(response.data.endingDate)    : defaultCampaign.endingDate                   ,
                      name                         : response.data.id                           ??                                         defaultCampaign.id                           ,
                      channelId                    : response.data.channelId                    ??                                         defaultCampaign.channelId                    ,
                      areaId                       : response.data.areaId                       ??                                         defaultCampaign.areaId                       ,
                      advertisingSpotsNumberPerDay : response.data.advertisingSpotsNumberPerDay ??                                         defaultCampaign.advertisingSpotsNumberPerDay ,
                      spotDuration                 : response.data.spotDuration                 ??                                         defaultCampaign.spotDuration                 ,
                      schedule                     : response.data.schedule                     ??                                         defaultCampaign.schedule                     ,
					  adSpotId                     : response.data.adSpotId                     ??                                         defaultCampaign.adSpotId                     ,
                                     };

           return {
                    code    : 1,
                    comment : 'Ads campaign updated successfully',
                    payload : ads
                  }
          }
     else {
           return handleError<AdsCampaign>(response.status, 'Error retrieving the sales campaign');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<AdsCampaign>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<AdsCampaign>(-102, 'Unknown error occurred');
   }
};
